// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumb_container__s5Qvw","containerItem":"BreadCrumb_containerItem__lK3ZV"};